export const button = {
    search: 'ค้นหา',
    confirm: 'ยืนยัน',
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
    close: 'ปิด'
}